import { Component, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-thread-group-type-dialog',
  templateUrl: './thread-group-type-dialog.component.html',
  styleUrls: ['./thread-group-type-dialog.component.less']
})
export class ThreadGroupTypeDialogComponent implements OnInit {

  constructor(public modal: NgbActiveModal,private modelService: NgbModal    ) { }
  @Input() threadGroupType:string

  ngOnInit() {
    console.log()
  }
  cancel() {
    this.modal.close(false);
  }
}
